var Events = {
	
	force: false,

	init: function() {
	var isTouchSupported = 'ontouchstart' in window;
	
	if (Events.force !== false) {
		switch(Events.force) {
			case 'mouse': isTouchSupported = false;break;
			case 'touch': isTouchSupported = true;break;
		}
	}

		if (isTouchSupported) {
			this.pointer = {
				"down" : "touchstart",
				"up" : "touchend",
				"move" : "touchmove"
			};		
		} else {
			this.pointer = {
				"down" : "mousedown",
				"up" : "mouseup",
				"move" : "mousemove"
			};
		}		
		
		if (navigator.userAgent.match(/webkit/i) != null) {
			this.pointer.wheel = "mousewheel";
		} else {
			this.pointer.wheel = "DOMMouseScroll";			
		}

		//console.log(this.pointer);
	},

	getWheelEvent: function(event) {
		var ev = {};

		ev.delta = event.originalEvent.wheelDelta ? event.originalEvent.wheelDelta : -event.originalEvent.detail * 40;
		ev.origin = event;

		return ev;
	},

	getPointerEvent: function(event) {
		var evt = {};
		
		if (event) {
			if (event.originalEvent && event.originalEvent.touches) {
				evt.origin = event.originalEvent;
//				var touches = evt.origin.changedTouches;
				var touches = evt.origin.touches;
				
				if (evt.origin.touches[0] && touches[0].pageX) {
					evt.pageX = touches[0].pageX;
					evt.pageY = touches[0].pageY;
				}
				
				evt.points = [];
				for(var no in touches) {
					if (touches[no].pageX != undefined) evt.points.push({pageX: touches[no].pageX, pageY: touches[no].pageY});
				}
				
			//$("#heading").html("changedTouches: " + touches.length + ", touched: " + evt.origin.touches.length);

		} else {
				evt.points = [];
				evt.origin = event;
				evt.points.push({pageX: event.pageX, pageY: event.pageY});
				if (event.pageX) {
					evt.pageX = event.pageX;
					evt.pageY = event.pageY;
				}
			}
			return evt;
		} else {
			return null;
		}
	}	
}